/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon } from '@heroicons/react/solid'
import { ShoppingBagIcon } from '@heroicons/react/outline'
import Header from '../components/Header'
import Link from 'next/link'
import { Container } from '../components/Container'

const links = [
    {
        title: 'Shop',
        href: '/products',
        description:
            'The most effective direct mail marketing for real estate investors on the market.',
        icon: ShoppingBagIcon,
    },
]

export default function FourOhFour() {
    return (
        <Container className="bg-white">
            <Header metaTitle="404" />
            <main className="max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-xl mx-auto py-16 sm:py-24">
                    <div className="text-center">
                        <p className="text-sm font-semibold text-olm uppercase tracking-wide">
                            404 error
                        </p>
                        <h1 className="mt-2 text-4xl font-extrabold text-olm-black tracking-tight sm:text-5xl">
                            This page does not exist.
                        </h1>
                        <p className="mt-2 text-lg text-gray-500">
                            The page you are looking for could not be found.
                        </p>
                    </div>
                    <div className="mt-12">
                        <h2 className="text-sm font-semibold text-gray-500 tracking-wide uppercase">
                            Popular pages
                        </h2>
                        <ul
                            role="list"
                            className="mt-4 border-t border-b border-gray-200 divide-y divide-gray-200">
                            {links.map((link, linkIdx) => (
                                <li key={linkIdx}>
                                    <Link href={link.href}>
                                        <a className="relative py-6 flex items-start space-x-4">
                                            <div className="flex-shrink-0">
                                                <span className="flex items-center justify-center h-12 w-12 rounded-lg bg-orange-50">
                                                    <link.icon
                                                        className="h-6 w-6 text-olm"
                                                        aria-hidden="true"
                                                    />
                                                </span>
                                            </div>
                                            <div className="min-w-0 flex-1">
                                                <h3 className="text-base font-medium text-olm-black">
                                                    <span className="rounded-sm focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-olm">
                                                        <span className="focus:outline-none">
                                                            <span
                                                                className="absolute inset-0"
                                                                aria-hidden="true"
                                                            />
                                                            {link.title}
                                                        </span>
                                                    </span>
                                                </h3>
                                                <p className="text-base text-gray-500">
                                                    {link.description}
                                                </p>
                                            </div>
                                            <div className="flex-shrink-0 self-center">
                                                <ChevronRightIcon
                                                    className="h-5 w-5 text-gray-400"
                                                    aria-hidden="true"
                                                />
                                            </div>
                                        </a>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-8">
                            <Link href="/">
                                <a className="text-base font-medium text-olm hover:text-olh">
                                    Or go back home
                                    <span aria-hidden="true"> &rarr;</span>
                                </a>
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
        </Container>
    )
}
